<button class="modal-menu-option" (click)="openMenu()">
  {{ translationKey + ".TRANSLATION" | translate }}
</button>


